// Lightweight prefetch for the 3D robot model.
// Called on hover of the Home link / logo so the .glb is warm in the HTTP cache
// by the time the user lands on Home and the <Canvas> boots.

const MODEL_URL = '/models/RobotExpressive.glb';
let preloaded = false;

export function preloadRobotModel() {
  if (preloaded || typeof window === 'undefined') return;
  preloaded = true;
  try {
    // 1) Insert a <link rel="prefetch"> hint (so DevTools/network show the intent)
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'fetch';
    link.href = MODEL_URL;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
    // 2) Fire an actual low-priority fetch to warm the browser cache
    //    fetch() respects HTTP caching, so useGLTF will later re-use the same bytes.
    fetch(MODEL_URL, { credentials: 'omit', cache: 'force-cache' }).catch(() => {});
  } catch { /* no-op */ }
}

// Attach hover handlers to a DOM element (returns a cleanup fn).
export function attachModelPrefetch(el) {
  if (!el) return () => {};
  const h = () => preloadRobotModel();
  el.addEventListener('mouseenter', h, { passive: true, once: true });
  el.addEventListener('touchstart', h, { passive: true, once: true });
  el.addEventListener('focus', h, { passive: true, once: true });
  return () => {
    el.removeEventListener('mouseenter', h);
    el.removeEventListener('touchstart', h);
    el.removeEventListener('focus', h);
  };
}
